module.exports = __webpack_public_path__ + "static/media/fight.07f9eafd.jpg";